import serviceimg from '../../../assets/images/SServices.png';
import PageHeader from '@/components/PageHeader';

function PharmacovigilanceAndDrugSafetySoftware() {
  return (
    <div className="font-sans">

      <PageHeader title='Our Services' imageUrl={serviceimg} breadcrumbs={['Home', 'Our Services', 'IT Solutions for Pharma', 'Pharmacovigilance & Drug Safety Software']} />

      <div className="max-w-[var(--max-width)] mx-auto px-4 sm:px-6 md:px-12 lg:px-20 xl:px-32 py-12 text-[#05326D]">

        <h2 className="text-xl font-bold text-[#05326D] flex items-center gap-2 mb-12">
          <span className="inline-block w-[6px] h-5 rounded-tr-sm rounded-br-sm bg-[#B5AB28]"></span>
          IT Solutions for Pharma
        </h2>

        <div className="flex items-center gap-2 mb-2">
          <span className="w-4 h-4 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Pharmacovigilance & Drug Safety Software
          </h3>
        </div>

        <p className='mb-4 text-[#05326D]'> 360° Automation for End-to-End PV Operations</p>

        <p className="mb-4 text-[#05326D]">
          Our Pharmacovigilance (PV) and Drug Safety Software is a fully integrated, cloud-based solution designed to manage the complete lifecycle of
          safety data—from adverse event intake to regulatory reporting. Built to meet global compliance standards including ICH E2B (R3), 21 CFR Part
          11, and GDPR, the system empowers PV teams to operate with speed, precision, and confidence.
        </p>
        <p className="mb-8 text-[#05326D]">
          Whether you’re managing clinical trial safety, post-marketing surveillance, or medical device vigilance, our platform offers intelligent
          automation, real-time analytics, and seamless workflow integration.
        </p>

        <hr className="border-t border-gray-300 mb-8" />


        <div className="flex items-center gap-2 mb-4 mt-2">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Global Compliance & Reporting Capabilities
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">CIOMS Reports</p>
        <p className="ml-2 mt-2 text-[#05326D]">XML Submissions</p>
        <p className="ml-2 mt-2 text-[#05326D]">MedWatch Forms</p>
        <p className="ml-2 mt-2 text-[#05326D]">Line Listings</p>
        <p className="ml-2 mt-2 text-[#05326D]">Signal Detection Summaries</p>
        <p className="ml-2 mt-2 text-[#05326D]">Literature Surveillance Outputs</p>
        <p className="ml-2 mt-2 text-[#05326D]">Fully aligned with MedDRA, GVP Modules, and ICH E2B (R3) standards</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Core Functional Modules
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Safety Case Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">Individual Case Safety Reports (ICSRs)</p>
        <p className="ml-2 mt-2 text-[#05326D]">Clinical Trial & Post-Marketing Safety Reporting</p>
        <p className="ml-2 mt-2 text-[#05326D]">PADER Listings</p>
        <p className="ml-2 mt-2 text-[#05326D]">Vaccine & Medical Device Vigilance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Product Inquiry & Response Tracking</p>
        <p className="ml-2 mt-2 text-[#05326D]">Academic PV Module for Training & Education</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Workflow & Automation
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Smart EV Triage for Case Segregation</p>
        <p className="ml-2 mt-2 text-[#05326D]">Multisource Inbox Integration</p>
        <p className="ml-2 mt-2 text-[#05326D]">MedDRA Auto-Update</p>
        <p className="ml-2 mt-2 text-[#05326D]">ICSR Validation, Submission & Tracking</p>
        <p className="ml-2 mt-2 text-[#05326D]">Case Routing & Workflow Management</p>
        <p className="ml-2 mt-2 text-[#05326D]">PQC (Product Quality Complaint) Handling</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Inquiry & Adverse Event Linkage</p>

        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Literature Monitoring
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Automated Primary & Secondary Literature Surveillance</p>
        <p className="ml-2 mt-2 text-[#05326D]">Intelligent ICSR Creation from Literature Sources</p>
        <p className="ml-2 mt-2 text-[#05326D]">Minimal Manual Intervention with High Accuracy</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Signal Detection
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Advanced Data Mining Algorithms</p>
        <p className="ml-2 mt-2 text-[#05326D]">Tabulated AE Summaries Based on GVP Guidelines</p>
        <p className="ml-2 mt-2 text-[#05326D]">Continuous Safety Surveillance & Risk Identification</p>



        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Exclusive Benefits
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Maximizes PV team efficiency by automating routine tasks</p>
        <p className="ml-2 mt-2 text-[#05326D]">Reduces manual effort while improving accuracy</p>
        <p className="ml-2 mt-2 text-[#05326D]">Rapid deployment as a cloud-based plug-in</p>
        <p className="ml-2 mt-2 text-[#05326D]">Configurable auto-checks aligned with client SOPs</p>
        <p className="ml-2 mt-2 text-[#05326D]">Pre-validated, ready-to-use solution</p>
        <p className="ml-2 mt-2 text-[#05326D]">No infrastructure investment required</p>
        <p className="ml-2 mt-2 text-[#05326D]">Fully GxP compliant, validated by global regulatory audits (USFDA, MHRA, Health Canada, ANVISA, MOH, CDSCO, TGA)</p>


        <div className="flex items-center gap-2 mb-4 mt-4">
          <span className="w-2 h-2 rounded-full bg-sky-300 flex-shrink-0"></span>
          <h3 className="text-lg font-bold text-[#05326D]">
            Designed For
          </h3>
        </div>
        <p className="ml-2 mt-2 text-[#05326D]">Pharmaceutical & Biotech Companies</p>
        <p className="ml-2 mt-2 text-[#05326D]">Medical Device Manufacturers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Vaccine Developers</p>
        <p className="ml-2 mt-2 text-[#05326D]">CROs & PV Service Providers</p>
        <p className="ml-2 mt-2 text-[#05326D]">Regulatory Affairs & Safety Teams</p>


        <p className="text-[#05326D] mt-4">
          Our PV software is not just a tool—it’s a strategic asset that transforms how safety data is captured, processed, and reported across the product
          lifecycle.
        </p>
      </div>
    </div>
  );
}

export default PharmacovigilanceAndDrugSafetySoftware;
